import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProvinceCitySelector from "components/provinceSelector";
import { useUpdateProfile } from "hooks/user";
import "./index.scss";
import useInfoContext from "hooks/useInfoContext";
import CustomModalSuccess from "components/modalSuccses";

const ReceiveCard = () => {
  const { userInfo } = useInfoContext();
  const [exactAddress, setExactAddress] = useState(
    userInfo?.postalAddress ? userInfo?.postalAddress : ""
  );
  const [postalCode, setPostalCode] = useState(
    userInfo?.postalCode ? userInfo?.postalCode : ""
  );
  const [provinceAlert, setProvinceAlert] = useState("");
  const [exactAddressAlert, setExactAddressAlert] = useState("");
  const [selectedProvince, setSelectedProvince] = useState(
    userInfo?.province ? userInfo?.province.toString() : ""
  );
  const [selectedCity, setSelectedCity] = useState(
    userInfo?.city ? userInfo?.city.toString() : ""
  );
  const [emptySelect, setEmptySelect] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => {
    setOpenModal(false);
    navigate("/on-card");
  };

  const { mutate: updateProfileRequest } = useUpdateProfile();

  const handleSend = () => {
    let valid = true;

    if (!selectedProvince || !selectedCity) {
      setEmptySelect(true);
    } else {
      setEmptySelect(false);
    }
    if (!selectedCity) {
      setProvinceAlert("پر کردن شهر و استان الزامیست");
    } else {
      setProvinceAlert("");
    }

    if (!exactAddress) {
      setExactAddressAlert("پر کردن این فیلدها الزامیست.");
      valid = false;
    } else {
      setExactAddressAlert("");
    }
    if (typeof valid === "boolean" && valid) {
      updateProfileRequest(
        {
          province: selectedProvince,
          city: selectedCity,
          postalAddress: exactAddress,
          postalCode: postalCode,
          onStage: "physicalOnCardRequested",
        },
        {
          onSuccess: (response) => {
            if (response.status === "OK") {
              setOpenModal(true);
            }
          },
        }
      );
    }
  };

  return (
    <Box className="container-receive-card">
      <CustomModalSuccess
        open={openModal}
        close={handleClose}
        title="آدرس شما با موفقیت تایید شد"
        detail="کارت شما در اسرع وقت ارسال خواهد شد"
      />
      <Box className="postalcode-page-wrapper">
        <Box className="child-box">
          <Box className="main-wrapper-personal">
            <Box className="personal-input">
              <Typography variant="h5" className="top-text">
                «آن کارت» شما به این آدرس ارسال خواهد شد. در صورت تایید، آدرس
                خود را تایید کنید
              </Typography>
              <Box className="input-box">
                <ProvinceCitySelector
                  selectedProvince={selectedProvince}
                  setSelectedProvince={setSelectedProvince}
                  selectedCity={selectedCity}
                  setSelectedCity={setSelectedCity}
                  emptySelect={emptySelect}
                />
                {/* <Box className="alert-text">
                  {provinceAlert && <span>{provinceAlert}</span>}
                </Box> */}
              </Box>

              <Box className="input-box-exactAddress">
                <textarea
                  type="text"
                  placeholder="آدرس دقیق پستی(استان، شهر،...)"
                  value={exactAddress}
                  onChange={(e) => {
                    setExactAddress(e.target.value);
                    if (e.target.value) setExactAddressAlert("");
                  }}
                  className={
                    exactAddressAlert ? "error exactAddress" : "exactAddress"
                  }
                />
                {/* <Box className="alert-text">
                  {exactAddressAlert && <span>{exactAddressAlert}</span>}
                </Box> */}
              </Box>

              <Box className="input-box">
                <input
                  type="text"
                  placeholder="کد پستی (اختیاری)"
                  value={postalCode}
                  onChange={(e) => {
                    setPostalCode(e.target.value);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className="bottom-bar-receive-card">
          <Button variant="contained" className="continue" onClick={handleSend}>
            تایید آدرس
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ReceiveCard;
